export const GET_DELIVERIES_LOADING = 'GET_DELIVERIES_LOADING'
export const GET_DELIVERIES_SUCSESS = 'GET_DELIVERIES_SUCSESS'
export const GET_DELIVERIES_ERROR = 'GET_DELIVERIES_ERROR'
export const SET_DELIVERIES = 'SET_DELIVERIES'